module.exports = __webpack_public_path__ + "static/media/Karte.6f45ba60.jpg";